import { api } from "./api";

/**
 * Download a server-generated file (e.g. a PDF) through the authenticated axios
 * instance, honoring the Content-Disposition filename.
 */
export async function downloadFile(path, params = {}) {
  const res = await api.get(path, { responseType: "blob", params });
  const cd = res.headers["content-disposition"] || "";
  const match = /filename="?([^"]+)"?/.exec(cd);
  const filename = match ? match[1] : "download.pdf";
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/**
 * Fetch a server-generated file through the authenticated axios instance and
 * return a blob object URL plus the Content-Disposition filename. Caller is
 * responsible for revoking the URL via URL.revokeObjectURL when done.
 */
export async function fetchBlobUrl(path, params = {}) {
  const res = await api.get(path, { responseType: "blob", params });
  const cd = res.headers["content-disposition"] || "";
  const match = /filename="?([^"]+)"?/.exec(cd);
  const filename = match ? match[1] : "download.pdf";
  return { url: URL.createObjectURL(res.data), filename };
}
